import { axiosBasic, axiosBearer } from "../config/axios-common";
import StringToDate from "../helpers/Strings/StringToDate";
import ResolveAttrValueIfNull from "../helpers/ValidateAttrs/ValidateAttrs";
import ColorSkin from "../models/ColorSkin";
import Language from "../models/Language";
import MaritalState from "../models/MaritalState";
import Nationality from "../models/Nationality";
import Professional from "../models/Professional";
import Sex from "../models/Sex";

const postInsertOrUpdateProfissional = async (data: any, professionalId: string) => {

    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            }
        }
        const response = await axiosBasic.post(`/sam/v1/professional/insertOrUpdate?professionalId=${encodeURIComponent(professionalId)}`, data, config);

        const responseData = await response.data;

        return responseData;

    } catch (e: any) {
        throw e;
    }
};

const postInsertOrUpdateProfissionalSpecialauthorization = async (data: any, professionalId: string) => {

    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            }
        }
        const response = await axiosBasic.post(`/sam/v1/professional/insertOrUpdate/specialauthorization?professionalId=${encodeURIComponent(professionalId)}`, data, config);

        const responseData = await response.data;

        return responseData;

    } catch (e: any) {
        throw e;
    }
};

const getProfissionalByRequest = async (requestId: string): Promise<Professional> => {

    const response = await axiosBearer.get(`/sam/v1/professional/getProfessionalByRequest?requestId=${encodeURIComponent(requestId)}`).then(response => {

        let professional = Professional.NewInstance();
        professional.Id = response.data.id;
        professional.Name = ResolveAttrValueIfNull(response.data.name);
        professional.CPF = ResolveAttrValueIfNull(response.data.cpf);
        professional.EncriptId = ResolveAttrValueIfNull(response.data.encriptId);
        professional.BirthDate = StringToDate(response.data.birthDate);
        professional.RG = ResolveAttrValueIfNull(response.data.rg);
        professional.IssuingAgency = ResolveAttrValueIfNull(response.data.issuingAgency);
        professional.CRM = ResolveAttrValueIfNull(response.data.crm);

        if (response.data.idMaritalStatus) {
            professional.IdMaritalStatus = response.data.idMaritalStatus;
            professional.MaritalState = new MaritalState(response.data.maritalState.id, response.data.maritalState.description);
        }

        if (response.data.idNationality) {
            professional.IdNationality = response.data.idNationality;
            professional.Nationality = new Nationality(response.data.nationality.id, response.data.nationality.description);
        }

        if (response.data.idColorSkin) {
            professional.IdColorSkin = response.data.idColorSkin;
            professional.ColorSkin = new ColorSkin(response.data.colorSkin.id, response.data.colorSkin.description);
        }

        if (response.data.idSex) {
            professional.IdSex = response.data.idSex;
            professional.Sex = new Sex(response.data.sex.id, response.data.sex.description);
        }

        if (response.data.languageIds && response.data.languageIds.length > 0) {
            professional.LanguageIds = response.data.languageIds;

            professional.Languages = new Array<Language>();

            for (let index = 0; index < response.data.languages.length; index++) {
                const element = response.data.languages[index];
                professional.Languages?.push(new Language(element.id, element.description))
            }

        }

        professional.FatherName = ResolveAttrValueIfNull(response.data.fatherName);
        professional.PartnerName = ResolveAttrValueIfNull(response.data.partnerName);
        professional.MotherName = ResolveAttrValueIfNull(response.data.motherName);
        professional.UsualName = ResolveAttrValueIfNull(response.data.usualName);
        professional.TelephonePhone = ResolveAttrValueIfNull(response.data.telephonePhone);
        professional.BusinessPhone = ResolveAttrValueIfNull(response.data.businessPhone);
        professional.CellPhone = ResolveAttrValueIfNull(response.data.cellPhone);
        professional.Email = ResolveAttrValueIfNull(response.data.email);
        professional.TasyCode = ResolveAttrValueIfNull(response.data.tasyCode);
        return professional;
    })

    const responseData = await response;

    return responseData;

};


const exportedObject = {
    postInsertOrUpdateProfissional,
    postInsertOrUpdateProfissionalSpecialauthorization,
    getProfissionalByRequest
};


export default exportedObject
